// extracted by mini-css-extract-plugin
export default {"sign":"zodiac_sign__yYq9d","sign_image":"zodiac_sign_image__Z1LNz"};